import { formatTicketNumber } from './index';
import environment from '../environment';

export const formatEscalateEmail = ({ to, smbName, ticketNumber, customerContact, escalationReason, conversation }) => {
  const { conversationHtml, conversationText } = formatConversationForEmail(conversation);
  const formattedTicketNumber = formatTicketNumber(ticketNumber);

  const htmlTemplate = generateHtmlTemplate({
    smbName,
    customerContact,
    escalationReason,
    conversationHtml,
    ticketNumber: formattedTicketNumber,
  });

  const textTemplate = [
    `Dear ${smbName},\n`,
    'The following customer support ticket was escalated from Simplr:',
    `Customer contact info: ${customerContact}`,
    `Ticket #${formattedTicketNumber}`,
    `${escalationReason}\n`,
    'Conversation history: \n',
    `${conversationText}Thank you,`,
    'Simplr',
  ].join('\n');

  return {
    to,
    from: environment.app.escalationSenderEmail,
    subject: 'Escalation from Simplr Support',
    text: textTemplate,
    html: htmlTemplate,
  };
};

const formatConversationForEmail = (conversation) => {
  let conversationHtmlRows = '';
  let conversationTextRows = '';

  conversation.allMessages.forEach((id) => {
    const { messageType, fromChannel, utcOriginalCreatedAt, subject, messageBody, direction } = conversation[id];

    // convert the time into east coast time in the same format we use in parseObjectToStoreObject
    const messageDateObj = new Date(utcOriginalCreatedAt);
    const formatedDate = `${messageDateObj.toLocaleDateString('en-US', {
      timeZone: 'America/New_York',
    })}  ${messageDateObj.toLocaleTimeString('en-US', { timeZone: 'America/New_York' })}`;

    // building conversation rows for html
    conversationHtmlRows += '<tr><td><br></td></tr>';
    conversationHtmlRows += `<tr><td>${messageType.replace('_', ' ')} from ${
      direction === 'OUTBOUND' || direction === 'INTERNAL' ? 'Simplr Expert' : fromChannel
    }, ${formatedDate}</td></tr>`;
    if (messageType !== 'SMS' && messageType !== 'INTERNAL_NOTE' && subject) {
      conversationHtmlRows += `<tr><td>Subject: ${subject}</td></tr>`;
    }
    conversationHtmlRows += `<tr><td>${messageBody}</td></tr>`;

    // building conversation rows for text
    conversationTextRows += `${messageType.replace('_', ' ')} from ${
      direction === 'OUTBOUND' || direction === 'INTERNAL' ? 'Simplr Expert' : fromChannel
    }, ${formatedDate}\n`;
    if (messageType !== 'SMS' && messageType !== 'INTERNAL_NOTE' && subject) {
      conversationTextRows += `Subject: ${subject}\n`;
    }
    conversationTextRows += `${messageBody}\n\n`;
  });

  return {
    conversationText: conversationTextRows,
    conversationHtml: `<table>
              <tr><td><br></td></tr>
              <tr><td>Conversation history:</td></tr>
              ${conversationHtmlRows}
              <tr><td><br></td></tr>
            </table>`,
  };
};

const generateHtmlTemplate = ({ smbName, customerContact, ticketNumber, escalationReason, conversationHtml }) => {
  return (
    `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
  <html xmlns="http://www.w3.org/1999/xhtml">
  <head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <title>Escalation from Simplr Support</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  </head>` +
    `<body>
      <table>
        <tr>
          <td>Dear ${smbName},</td>
        </tr>
        <tr><td><br></td></tr>
        <tr>
          <td>The following customer support ticket was escalated from Simplr:</td>
        </tr>
        <tr>
          <td>Customer contact info: ${customerContact}</td>
        </tr>
        <tr>
          <td>Ticket #${ticketNumber}</td>
        </tr>
        <tr>
          <td>${escalationReason}</td>
        </tr>
      </table>
      ${conversationHtml}
      <table>
        <tr>
          <td>Thank you,</td>
        </tr>
        <tr>
          <td>Simplr</td>
        </tr>
      </table>
    </body>
  </html>`
  );
};

/**
 * Check if email has domain
 * @param email string
 * @param domain string
 * @returns boolean
 */
export const hasDomain = (email, domain) => {
  return email.endsWith(`@${domain}`);
};
